import * as z from 'zod';
import { paginatedSchema } from '@noor/types';

export * from './contract';

/* Legacy Courier item schema preserved for compatibility */
export const courierStatusSchema = z.enum(['available', 'busy', 'offline']);
export type CourierStatus = z.infer<typeof courierStatusSchema>;

export const courierSchema = z.object({
  id: z.string(),
  name: z.string(),
  phone: z.string(),
  status: courierStatusSchema,
  vehicle: z.enum(['bike', 'car', 'scooter', 'walk']),
  activeOrders: z.number().int().nonnegative(),
  rating: z.number().min(0).max(5),
  city: z.string(),
});
export type Courier = z.infer<typeof courierSchema>;

export const courierListSchema = paginatedSchema(courierSchema);
export type CourierList = z.infer<typeof courierListSchema>;
